module.exports = __webpack_public_path__ + "static/media/proj3_img2.f2cba6fc.jpg";